import request from './plugins/request'

// 注册
export let registration = (params = {}) => {
  return request({
    url: '/registration',
    params: params,
    method: 'post'
  })
}